import { render, staticRenderFns } from "./forgetPasswordForm.vue?vue&type=template&id=49e3d38c&scoped=true"
import script from "./forgetPasswordForm.vue?vue&type=script&lang=js"
export * from "./forgetPasswordForm.vue?vue&type=script&lang=js"
import style0 from "./forgetPasswordForm.vue?vue&type=style&index=0&id=49e3d38c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49e3d38c",
  null
  
)

export default component.exports